import { LicensePlate } from '../types/userData.interface'
import { Vehicle } from '../types/vehicle.interface'

const mapVehiclesWithPlates = (vehicles: Vehicle[], plates: LicensePlate[]): Vehicle[] => {
    if (!vehicles || !plates) return []
    return vehicles.map((vehicle) => {
        const plate = plates.find((plate) => plate.id === vehicle.plate_id)
        return {
            ...vehicle,
            plate_id: plate?.id,
            plate: plate?.plate,
            country: plate?.country
        }
    })
}

export default mapVehiclesWithPlates
